import React, { useState, useEffect, useRef } from 'react';
import {NavLink, useLocation} from 'react-router-dom';
import './BottomNav.css';
import { useLanguage } from '../i18n/LanguageContext';

const BottomNav = () => {
    const [hidden, setHidden] = useState(false);
    const lastScrollPos = useRef(0);
    const location = useLocation();
    const { t } = useLanguage();
    const isPaymentPage = location.pathname.startsWith('/product/');

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollPos = window.scrollY;
            if (currentScrollPos <= 0) {
                setHidden(false);
            } else if (currentScrollPos > lastScrollPos.current) {
                setHidden(true);
            } else {
                setHidden(false);
            }
            lastScrollPos.current = currentScrollPos;
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    if (isPaymentPage) {
        return null;
    }

    return (
        <nav className={`bottom-nav ${hidden ? 'hidden' : ''}`}>
            <NavLink
                to={`/${location.search}`}
                className={({ isActive }) =>
                    isActive ? 'bottom-nav-item active' : 'bottom-nav-item'
                }
            >
                <span className="bottom-nav-icon">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="#9697A4"
                      viewBox="0 0 256 256"
                  >
                    <path d="M232,96a7.89,7.89,0,0,0-.3-2.2L217.35,43.6A16.07,16.07,0,0,0,202,32H54A16.07,16.07,0,0,0,38.65,43.6L24.31,93.8A7.89,7.89,0,0,0,24,96h0v16a40,40,0,0,0,16,32v72a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V144a40,40,0,0,0,16-32V96ZM54,48H202l11.42,40H42.61Zm50,56h48v8a24,24,0,0,1-48,0Zm-16,0v8a24,24,0,0,1-35.12,21.26,7.88,7.88,0,0,0-1.82-1.06A24,24,0,0,1,40,112v-8ZM200,208H56V151.2a40.57,40.57,0,0,0,8,.8,40,40,0,0,0,32-16,40,40,0,0,0,64,0,40,40,0,0,0,32,16,40.57,40.57,0,0,0,8-.8Zm4.93-75.8a8.08,8.08,0,0,0-1.8,1.05A24,24,0,0,1,168,112v-8h48v8A24,24,0,0,1,204.93,132.2Z" />
                  </svg>
                </span>
                <span className="bottom-nav-label">{t('nav.shop')}</span>
            </NavLink>

            <NavLink
                to={`/esims${location.search}`}
                className={({isActive}) =>
                    isActive ? 'bottom-nav-item active' : 'bottom-nav-item'
                }
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#9697A4" viewBox="0 0 256 256">
                    <path
                        d="M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM200,216H56V40h92.69L200,91.31V216ZM176,112H80a8,8,0,0,0-8,8v72a8,8,0,0,0,8,8h96a8,8,0,0,0,8-8V120A8,8,0,0,0,176,112Zm-8,72H152V152a8,8,0,0,0-16,0v32H120V152a8,8,0,0,0-16,0v32H88V128h80Z"></path>
                </svg>
                <span className="bottom-nav-label">{t('nav.esim')}</span>
            </NavLink>

            <NavLink
                to={`/profile${location.search}`}
                className={({isActive}) =>
                    isActive ? 'bottom-nav-item active' : 'bottom-nav-item'
                }
            >
                <span className="bottom-nav-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#9697A4" viewBox="0 0 256 256"><path
                      d="M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z"></path>
                  </svg>
                </span>
                <span className="bottom-nav-label">{t('nav.profile')}</span>
            </NavLink>
        </nav>
    );
};

export default BottomNav;
